import { environment } from 'src/environments/environment';
import { z } from 'zod';
import { Api } from '../api';
import { HttpService } from '../../services/http/http.service';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { ApiResponseSchema } from '../api-response';
import { ProvisionUserData, ProvisionUserSchema } from './schemas/provision-user';

export const WAGER_ENDPOINTS = {
  FCM_TOKEN: 'fcm-token',
  NICK: 'nick',
  PROVISION_USER: 'provision-user',
} as const;

/* 
    Note: all functions can throw a ApiResponseError (thrown from Api in 'private/api')
    if there is response error. Client should consume this, for appropriate
    error handling. 
*/
export class WagerApi {
  private api: Api;

  private constructor(httpService: HttpService, analyticsService: AnalyticsService) {
    this.api = new Api(environment.wagerApi, httpService, analyticsService);
  }

  public static request(httpService: HttpService, analyticsService: AnalyticsService) {
    return new WagerApi(httpService, analyticsService);
  }

  public async setProvisionalUser(): Promise<ProvisionUserData> {
    const ProvisionUserResponseSchema = ApiResponseSchema(ProvisionUserSchema);
    type ProvisionUserResponse = z.infer<typeof ProvisionUserResponseSchema>;

    const response = await this.api.post<ProvisionUserResponse, undefined>(
      WAGER_ENDPOINTS.PROVISION_USER,
      ProvisionUserResponseSchema,
    );
    return response.data;
  }
}
